import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { getRedirectOnImportPath } from "@/components/Workflow/redirectPath";
import { withPrefix } from "@/utils/redirect";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FromFileOrUrl',
    setup(__props) {
        const loading = ref(false);
        const sourceURL = ref(null);
        const sourceFile = ref(null);
        const errorMessage = ref(null);
        const acceptedWorkflowFormats = ".ga, .yml";
        const isImportDisabled = computed(() => {
            return !sourceFile.value && !sourceURL.value;
        });
        const importTooltip = computed(() => {
            return isImportDisabled.value
                ? "You must provide a workflow archive URL or file."
                : sourceURL.value
                    ? "Import workflow from URL"
                    : "Import workflow from File";
        });
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        function autoAppendJson(urlString) {
            const sharedWorkflowRegex = /^(https?:\/\/[\S]+\/u\/[\S]+\/w\/[^\s/]+)\/?$/;
            const matches = urlString.match(sharedWorkflowRegex);
            const bareUrl = matches?.[1];
            if (bareUrl) {
                return `${bareUrl}/json`;
            }
            else {
                return urlString;
            }
        }
        const router = useRouter();
        async function submit(ev) {
            ev.preventDefault();
            const formData = new FormData();
            if (sourceFile.value) {
                formData.append("archive_file", sourceFile.value);
            }
            if (sourceURL.value) {
                const url = autoAppendJson(sourceURL.value);
                formData.append("archive_source", url);
            }
            loading.value = true;
            try {
                const response = await axios.post(withPrefix("/api/workflows"), formData);
                const path = getRedirectOnImportPath(response.data);
                router.push(path);
            }
            catch (error) {
                let message = null;
                if (axios.isAxiosError(error)) {
                    message = error.response?.data?.err_msg;
                }
                errorMessage.value = message || "Import failed for an unknown reason.";
            }
            finally {
                loading.value = false;
            }
        }
        return { __sfc: true, loading, sourceURL, sourceFile, errorMessage, acceptedWorkflowFormats, isImportDisabled, importTooltip, hasErrorMessage, autoAppendJson, router, submit, BAlert, BButton, BForm, BFormGroup, BFormInput, LoadingSpan };
    }
});
